import React from 'react'
import Button from '../Button/Button'
import Style from './Footer.css'
import Pattern from '../../assets/national-scholars-pattern.svg'

const Footer = (props) => {
  let year = new Date().getFullYear()
  return (
    <section style={Style} className="footer bg-color-arizona-red">
      <div className="container">
        <div className="top">
          <div className="footer-wrap">
            <div className="honors-pattern">
              <img src={Pattern} alt="" />
            </div>
            <div className="intro-wrap flex-basis-full">
              <h2>Choose Arizona</h2>

              <h3 className="psuedo-before-color-bloom">
                Your dreams, your questions, your boldest ideas – bring them all to the forefront at
                the University of Arizona.
              </h3>

              <div className="footer-accept-wrap">
                <div className="border-bloom">
                  <p className="accept">
                    To accept your award offer and automatic admission into the Franke Honors
                    College, all you have to do is apply for admission to the University of Arizona.
                  </p>
                  <Button
                    linkId="apply-footer-cta"
                    link="https://slate.admissions.arizona.edu/apply/"
                  >
                    Apply
                  </Button>
                </div>
                <div className="footer-copy-wrap  flex-basis-full">
                  <p className="applied">
                    If you’ve already applied, be sure to complete your enrollment in your Next
                    Steps Center to make things official.
                  </p>
                  <Button
                    linkId="next-steps-center-cta"
                    link="https://nextsteps.arizona.edu/nextsteps/?trackingLink=True"
                  >
                    Visit Next Steps Center
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bottom">
          <span className="underline">
            <a
              href="https://financialaid.arizona.edu/types-of-aid/scholarships/2024-2025-terms-and-conditions"
              target="_blank"
              rel="nopener"
              id="footer-security-privacy"
            >
              University Information Security and Privacy
            </a>
          </span>
          <span>© {year} Arizona Board of Regents on behalf of the University of Arizona</span>
        </div>
      </div>
    </section>
  )
}

export default Footer
